<template>
  <validation-observer
    ref="revenueSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="revenueSaveModal"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm khoản thu' : 'Cập nhật khoản thu'"
      @show="onShow"
      @hide="onHide"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên khoản thu <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Tên khoản thu"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetRevenue.name"
              name="name"
              placeholder="Nhập tên khoản thu"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="type_id">
          <template v-slot:label>
            Loại khoản thu <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Loại khoản thu"
            rules="required"
          >
            <v-select
              v-model="targetRevenue.type_id"
              :options="revenueOptions"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="is_exemption">
          <template v-slot:label>
            Miễn giảm <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Miễn giảm"
            rules="required"
          >
            <v-select
              v-model="targetRevenue.is_exemption"
              :options="exemptionOptions"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="status">
          <template v-slot:label>
            Trạng thái <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Trạng thái"
            rules="required"
          >
            <v-select
              v-model="targetRevenue.status"
              :options="statusOptions"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

<!--        <b-form-group label-for="orderNo">-->
<!--          <template v-slot:label>-->
<!--            Thứ tự <span class="text-danger">*</span>-->
<!--          </template>-->
<!--          <validation-provider-->
<!--            #default="{ errors }"-->
<!--            name="Thứ tự"-->
<!--            rules="required"-->
<!--          >-->
<!--            <b-form-input-->
<!--              id="orderNo"-->
<!--              v-model="targetRevenue.orderNo"-->
<!--              name="orderNo"-->
<!--              placeholder="Nhập thứ tự"-->
<!--              :state="getElementState(errors)"-->
<!--            />-->
<!--            <small class="text-danger">{{ errors[0] }}</small>-->
<!--          </validation-provider>-->
<!--        </b-form-group>-->
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('revenueSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'

export default {
  name: 'StudentScholarshipSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    revenue: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      targetRevenue: {
        organization_id: getUser().orgId,
        name: '',
        type_id: null,
        is_exemption: 1,
        status: 1,
        orderNo: 1,
      },
      statusOptions: [
        { value: 1, label: 'Đang hoạt động' },
        { value: 0, label: 'Không hoạt động' },
      ],
      exemptionOptions: [
        { value: 1, label: 'Có miễn giảm' },
        { value: 0, label: 'Không miễn giảm' },
      ],
      required,
    }
  },
  computed: {
    ...mapGetters({
      allRevenueTypes: 'revenue/allRevenueTypes',
    }),
    isCreated() {
      return !this.revenue
    },
    revenueOptions() {
      return this.allRevenueTypes.map(item => ({ value: item.id, label: item.name }))
    },
  },
  methods: {
    ...mapActions({
      createRevenue: 'revenue/createRevenue',
      updateRevenue: 'revenue/updateRevenue',
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    onShow() {
      if (this.revenue) {
        this.targetRevenue = { ...this.revenue }
      }
    },
    onHide() {
      this.$refs
        .revenueSaveFormRef
        .reset()
      this.targetRevenue = {
        organization_id: getUser().orgId,
        name: '',
        code: '',
        type_id: null,
        is_exemption: 1,
        status: 1,
        orderNo: 1,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .revenueSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createRevenue(this.targetRevenue)
            : await this.updateRevenue(this.targetRevenue)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              showSuccessToast(this, message)
              if (type === 'hide') {
                this.$bvModal.hide('revenueSaveModal')
              }
              this.$emit('succeed')
            } else {
              showErrorToast(this, message)
            }
          }
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>
